<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="400"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            Seleccionar variantes
        </div>
        <div class="pl-3 pt-3 pr-3">
            <v-card>
                <v-card-title class="pt-1 pb-1">
                    <span class="subtitle-2">Lista de variantes disponibles</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-1 pb-1 pl-1 pr-1">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-treeview
                                    selectable
                                    selected-color="blue"
                                    activatable
                                    color="blue"
                                    :items="options_tree"
                                    open-on-click
                                    v-model="form.variant_option_id"
                                ></v-treeview>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </div>
        <div class="pl-3 pt-3 pr-3">
            <template>
                <v-row>
                    <v-col cols="6">
                        <v-btn @click="handleCancel" 
                            block 
                            height="40" 
                            outlined 
                            color="red darken-1">
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn
                            dark 
                            color="green darken-1" 
                            block 
                            height="40" 
                            @click="handleAccept">
                            Aceptar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </div>
    </v-navigation-drawer>
</template>
<script>

import {mapActions, mapState} from 'vuex';

import Tools from '../../helpers/Tools';

export default {
    name: 'AddVariant',
    data () {
        return {
            drawer: false,
            options_tree: [],
            action: 'create',
            form: {
                variant_id: null,
                variant_option_id: []
            }
        }
    },
    computed: {
        ...mapState('variants', [
            'variants',
            'variant_options',
            'variants_rows'
        ])
    },
    methods: {
        ...mapActions('variants', [
            'getVariants',
            'getVariantOptions',
            'setVariantsHeader',
            'setVariantsRows',
            'addVariantRow'
        ]),
        show () {
            this.clearForm();
            this.loadOptionSelected(this.variants_rows);
            this.drawer = !this.drawer;
        },
        loadOptionSelected (rows) {
            let selected = [];
            for (let row of rows) {
                for (let key in row) {
                    if (key.includes('_id')) {
                        selected.push(parseInt(row[key]));
                    }
                }
            }

            this.form.variant_option_id = selected;
        },
        clearForm () {
            this.variant_id = null;
            this.variant_option_id = [];
        },
        closeForm () {
            this.clearForm();
            this.drawer = false;
        },
        customText(item){
            let text = item.name
            
            return text
        },
        customTextOptions (item) {
            let text = item.option_name
            
            return text
        },
        generateTree () {
            this.options_tree = Tools.generateVariantsTree(this.variants);
        },
        handleCancel () {
            this.closeForm();
        },
        handleAccept () {
            let headerOption = null;
            let parents = [];
            let itemData = {};
            let listOptions = [];
            for (let option of this.form.variant_option_id) {
                let optionData = Tools.getElementById(this.variant_options, option);
                let optionParent = Object.assign({}, optionData.variant);

                let indexFounded = Tools.findIndexFromItem(parents, optionParent.id);

                if (indexFounded == -1) {
                    parents.push(optionParent);
                }
                
                let variantItem = {
                    id: optionData.id,
                    variant_id: optionData.variant_id,
                    option_name: optionData.option_name
                }
                listOptions.push(variantItem);
            }
            this.closeForm();
            this.createListHeaders(parents);
            this.createStructureVariants(parents, listOptions);

        },
        createListHeaders (parents) {
            let headers = [];
            for (let parent of parents) {
                headers.push({
                    text: parent.name, 
                    value: parent.name.toLowerCase(), 
                    align: 'left', 
                    sortable: false, 
                    class: 'header-table'
                });
            }
            headers.push({
                text: 'CODIGO DE BARRAS',
                value: 'barcode',
                align: 'start',
                sortable: false,
                class: 'header-table',
                width: 220
            });
            headers.push({
                text: 'PRECIO UNT.',
                value: 'unit_price',
                align: 'end',
                sortable: false,
                class: 'header-table',
                width: 150
            });
            headers.push({
                text: 'PRECIO POR MAYOR',
                value: 'wholesale_price',
                align: 'end',
                sortable: false,
                class: 'header-table',
                width: 150
            });
            headers.push({
                text: 'PRECIO PREFERENCIAL',
                value: 'preferential_price',
                align: 'end',
                sortable: false,
                class: 'header-table',
                width: 180
            });
            headers.push({
                text: '',
                value: 'action',
                align: 'end',
                sortable: false,
                class: 'header-table',
                width: 90
            });
            this.setVariantsHeader(headers);
        },
        createStructureVariants (parents, listOptions) {
            let listVariants = [];
            for (let parent of parents) {
                let options = [];
                for (let option of listOptions) {
                    if (parent.id == option.variant_id) {
                        options.push(option);
                    }                    
                }
                listVariants.push({
                    id: parent.id,
                    name: parent.name,
                    options: options
                });
            }
            let variantsTable = Tools.generateVariantTableData(listVariants);
            this.addRowsToTableVariants(variantsTable);
        },
        addRowsToTableVariants (list) {
            for (let item of list) {
                let index = this.getIndexByRowId(item.row_id);
                if (index == -1) {
                    this.addVariantRow(item);
                }
            }
        },
        getIndexByRowId (row_id) {
            let indexFounded = -1;
            this.variants_rows.forEach((element, index) => {
                if (element.row_id == row_id) {
                    indexFounded = index;
                }
            });

            return indexFounded;
        },
        async loadData () {
            await this.getVariants();
            await this.getVariantOptions();
            this.generateTree(); 
        }
    },
    created () {
        this.loadData();
    }
}
</script>

<style scoped>

</style>